module.exports = __webpack_public_path__ + "img/spr_vjd-450x300.b4520db4.png";